import { BaseClass } from "./base";

export class Damage extends BaseClass {
}


// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/domain/damage.ts